import { ReactElement } from 'react';

import { Stack } from '@mui/material';

import games from './data';

import GamesList from '../Games';

export default function CasinoGames(): ReactElement {
  return (
    <Stack direction='column' justifyContent='center' alignItems='stretch' spacing={3}>
      <GamesList games={games} />
    </Stack>
  );
}
